<script lang="ts">
/**
 * Colored badge for a tag, optionally linking to filtered items.
 *
 * Renders a `UBadge` with the tag's configured color. When `linked`
 * is true (default), clicking navigates to the items index filtered
 * by that tag.
 *
 * @example
 * ```vue
 * <TagBadge :tag="tag" />
 * <TagBadge :tag="tag" :linked="false" />
 * ```
 */
export interface TagBadgeProps {
  /** Tag data including name and color class. */
  tag: TagSummary
  /** Render as a link to filtered items list. @defaultValue `true` */
  linked?: boolean
}
</script>

<script setup lang="ts">
import { itemsPath } from "@/routes"
import type { TagSummary } from "@/types/models"

withDefaults(defineProps<TagBadgeProps>(), {
  linked: true,
})
</script>

<template>
  <UBadge
    :color="tag.color_class as any"
    variant="subtle"
    size="sm"
    :to="linked ? itemsPath() + `?tag=${encodeURIComponent(tag.name)}` : undefined"
  >
    {{ tag.name }}
  </UBadge>
</template>
